import React, { memo, useCallback } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import TableItem from "./TableItem";
import TableItemExtra from "../TableItemExtra";

function TableBody({
  ActionButtonsComponent,
}: {
  ActionButtonsComponent: any;
}) {
  const tableContext = useTableCtx()!;

  const { tableData } = tableContext;

  const getActionButtonsComponent = useCallback(
    (props: any) => {
      if (!ActionButtonsComponent) return null;
      return <ActionButtonsComponent {...props} />;
    },
    [ActionButtonsComponent],
  );

  return (
    <tbody>
      {tableData?.length > 0 &&
        tableData?.map(
          ({ id, data, crudData, extraData, extraDataPreset }, rowIndex) => {
            return (
              <React.Fragment key={`${id}-${rowIndex}`}>
                <TableItem
                  tableItemId={id}
                  crudData={crudData}
                  tableItemData={data}
                  ActionButtonsComponent={
                    ActionButtonsComponent
                      ? getActionButtonsComponent
                      : undefined
                  }
                />
                {extraData?.map((extraDataItem, idx) => {
                  return (
                    <TableItemExtra
                      extraData={extraDataItem}
                      extraDataPreset={extraDataPreset}
                      extraDataRowIndex={idx}
                      extraDataRowsCount={extraData.length}
                      key={idx}
                    />
                  );
                })}
              </React.Fragment>
            );
          },
        )}
    </tbody>
  );
}

export default memo(TableBody);
